<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title link="/about" title="About"></header-title>
      </div>
    </page-header>
    <div id="copy" class="body">
      <p>{{ studio308.description }}</p>
      <p>We do a lot of things. Anything from fleshing out an idea and figuring out how to implement it, or building out what's already planned, or maybe just fixing and maintaining something that already exists. We do a lot of things. And we really enjoy doing it.</p>
      <p>What we love is to help great people and companies realize great products. Time is precious, and because of that we make sure that we believe in the people we work with. It could be that their product is going to do a lot of good, or that we share similar values with the people involved, but whatever the reason they came to work with us, our clients are all very special to us.</p>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
export default {
  name: 'about',
  data () {
    return {
      studio308: DataStore.studio308
    }
  },
  components: {
    HeaderTitle,
    PageHeader
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?615f8d46